<template>
  <v-card>
    <v-toolbar flat color="primary">
      <v-toolbar-title>Manage API Tokens</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <div class="text--primary">
        You may delete any of your existing tokens if they are no longer needed.
      </div>
    </v-card-text>
    <v-card-text>
      <v-list two-line>
        <template v-for="token in tokens">
          <v-list-item :key="token.id">
            <v-list-item-content>
              <v-list-item-title>
                {{ token.name }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="token.last_used_at">
                Last used {{ token.last_used_at }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon>
              <token-permissions :token="token" :available-permissions="availablePermissions">
                Permissions
              </token-permissions>
              <confirm-delete :token="token">
                Delete
              </confirm-delete>
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import ConfirmDelete from '@/Components/API/ConfirmDelete'
import TokenPermissions from '@/Components/API/TokenPermissions'
export default {
   components: { ConfirmDelete, TokenPermissions },
   props: {
      tokens: {
         type: Array,
         default () { return [] }
      },
      availablePermissions: {
         type: Array,
         required: true
      },
   },
   methods: {

   }
}
</script>

<style>
</style>
